"use strict";

var _context, _context2;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _ifFeature = require("./if-feature");
_forEachInstanceProperty(_context = _Object$keys(_ifFeature)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ifFeature[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ifFeature[key];
    }
  });
});
var _isEnabled = require("./is-enabled");
_forEachInstanceProperty(_context2 = _Object$keys(_isEnabled)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isEnabled[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isEnabled[key];
    }
  });
});